import { ccfRoutes } from '@app/ccf/ccf-routes';
import Text from '@shared/components/content/text';
import GuideTemplate from '@shared/components/guide-template';
import { useFormContext } from 'react-hook-form';
import {
  generatePath,
  useNavigate,
  useOutletContext,
  useParams,
} from 'react-router-dom';
import SupplyFlowForm from '../components/supply-flow-form';
import { SupplyFlowContext } from '../supply-flow-layout';

export default function SupplyFlowReviewPage() {
  const navigate = useNavigate();
  const { report_uuid } = useParams();

  const context = useOutletContext<SupplyFlowContext>();
  const { updateMode, flowUuid } = context;
  const { trigger } = useFormContext();

  const onNext = async () => {
    const isValid = await trigger('segments');
    if (isValid) {
      navigate(
        generatePath(ccfRoutes.SUPPLY_FLOW_ADD_WEIGHT, {
          report_uuid,
          flow_uuid: flowUuid || '',
        })
      );
    }
  };

  return (
    <GuideTemplate
      preTitle="Add supply flow"
      title="Review flow"
      description={
        <Text>
          We&apos;ve generated a flow for you below, trying to model the average
          journey that your goods take to reach you from your suppliers. You can
          add or amend the steps if you have more accurate information
          available.
        </Text>
      }
      primaryActionText="Next"
      primaryActionProps={{ onClick: onNext }}
      secondaryActionText="Back"
      secondaryActionProps={{
        onClick: () =>
          navigate(
            generatePath(ccfRoutes.SUPPLY_FLOW_ABOUT_SUPPLIERS, {
              report_uuid,
              flow_uuid: flowUuid || '',
            })
          ),
        className: !updateMode ? '' : 'hidden',
      }}
    >
      <div className="w-[700px]">
        <SupplyFlowForm />
      </div>
    </GuideTemplate>
  );
}
